import { useContext } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { LiveContext } from "./LiveContext";
import { RemoteComponent, RemoteComponentProps } from "./RemoteComponent";
import { usePropMerge } from "./usePropMerge";
import { UpperBound } from "./LiveComponentSource";

export const LiveComponent = <T extends UpperBound = UpperBound>({
  props,
  fieldOverrideAllowList: allowedCollisions = [],
  ...rest
}: RemoteComponentProps<T>) => {
  const { tier, liveProps: prevProps, xbAppName } = useContext(LiveContext);
  const pathParams = useParams<Record<string, string>>();
  const [queryParams] = useSearchParams();
  const liveProps = usePropMerge(
    { allowedCollisions },
    tier !== 0 ? prevProps : {},
    tier === 0 ? pathParams : {},
    tier === 0 ? Object.fromEntries(queryParams.entries()) : {},
    props ?? {}
  );

  return (
    <LiveContext.Provider value={{ tier: tier + 1, liveProps, xbAppName }}>
      <RemoteComponent props={liveProps} {...rest} />
    </LiveContext.Provider>
  );
};
